import { put, takeLatest, call } from 'redux-saga/effects';
import {
  LOGIN_USER,
  FORGOT_PWD,
  CHANGE_PWD,
  LOGOUT_USER,
  LOGGED_USER
} from 'redux/types';
import apiRequest from '@utils/request';
import { browserHistory } from '@src/App';
import {
  loginUserInProgress,
  loginUserSuccess,
  loginUserFailure,
  changePasswordUserInProgress,
  changePasswordUserSuccess,
  changePasswordUserFailure,
  logoutUserInProgress,
  logoutUserSuccess,
  logoutUserFailure,
  loggedUserInProgress,
  loggedUserSuccess,
  loggedUserFailure
} from '@redux/actions/AuthActions';
import { toast } from 'react-toastify';
import { saveState, deleteCookie, loadState } from '@utils/helpers';

// MOVE API CALLS
export const setLogin = (body) => {
  return apiRequest('/users/login', {
    method: 'POST',
    body
  });
};

export const setForgotPwd = (body) => {
  return apiRequest('/users/forgottenpassword', {
    method: 'POST',
    body
  });
};

export const setChangePwd = (body) => {
  return apiRequest('/users/modifypassword', {
    method: 'POST',
    body
  });
};

export const setLogout = (body) => {
  return apiRequest('/users/logout', {
    method: 'POST',
    body
  });
};

// TODO: move to utils and reuse
export const toastErrorHelper = (msg) => {
  toast.error(msg, {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    progress: 0
  });
};

export function* getLoggedUser() {
  try {
    yield put(loggedUserInProgress());

    const cookie = loadState();

    // TODO: check for server session as well

    if (cookie.data && cookie.data.user_id) {
      yield put(loggedUserSuccess(true));
      browserHistory.push('/panel');
    } else {
      yield put(loggedUserFailure(true));
    }
  } catch (error) {
    console.warn('Error on autologin', error);
    yield put(loggedUserFailure(error));
  }
}

export function* watchLoggedUser() {
  yield takeLatest(LOGGED_USER.START, getLoggedUser);
}

export function* setUserLogin({ user, pass }) {
  try {
    yield put(loginUserInProgress());

    if (!user) {
      toastErrorHelper('Please fill with your user!');
      return;
    }
    if (!pass) {
      toastErrorHelper('Please fill with your password!');
      return;
    }

    const obj = {
      email: user,
      password: pass,
      // TODO: remove fixed deal ID
      deal_id: 1
    };

    const result = yield call(setLogin, obj);

    saveState(result.data);

    if (result.data.body === 'Success') {
      // browserHistory.push('/panel');
      yield put(loginUserSuccess(result.data));
    } else {
      yield put(loginUserFailure());
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    toastErrorHelper('Invalid user or password!');
    console.warn('Error on login', error);
    yield put(loginUserFailure(error));
  }
}

export function* watchSetUserLogin() {
  yield takeLatest(LOGIN_USER.START, setUserLogin);
}

export function* setUserChangePwd({ payload }) {
  const { email, password, password2, token } = payload;
  try {
    yield put(changePasswordUserInProgress());

    if (!email) {
      toastErrorHelper('Please fill with your user!');
      return;
    }
    if (!password) {
      toastErrorHelper('Please fill with your password!');
      return;
    }
    if (!password && password !== password2) {
      toastErrorHelper("Your password doesn't match!");
      return;
    }

    const obj = {
      email,
      password,
      token,
      // TODO: remove fixed deal ID
      deal_id: 1
    };

    const result = yield call(setChangePwd, obj);

    if (result.data.body === 'Success') {
      browserHistory.push('/');
      toastErrorHelper(
        'Your password was changed sucessefully! You can login in now.'
      );

      yield put(changePasswordUserSuccess(result.data));
    } else {
      yield put(changePasswordUserFailure());
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    toastErrorHelper('Invalid user or password!');
    console.warn('Error on changePwd', error);
    yield put(changePasswordUserFailure(error));
  }
}

export function* watchSetUserChangePwd() {
  yield takeLatest(CHANGE_PWD.START, setUserChangePwd);
}

export function* setUserForgotPwd({ payload }) {
  try {
    yield put(changePasswordUserInProgress());

    if (!payload) {
      toastErrorHelper('Please fill with your user!');
      return;
    }

    const obj = {
      email: payload,
      // TODO: remove fixed deal ID
      deal_id: 1
    };

    const result = yield call(setForgotPwd, obj);

    if (result.data.body === 'Success') {
      toastErrorHelper('Check your e-mail and reset your password!');
      browserHistory.push('/');
      yield put(changePasswordUserSuccess(result.data));
    } else {
      yield put(changePasswordUserFailure());
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    toastErrorHelper('Invalid user or password!');
    console.warn('Error on changePwd', error);
    yield put(changePasswordUserFailure(error));
  }
}

export function* watchSetUserForgotPwd() {
  yield takeLatest(FORGOT_PWD.START, setUserForgotPwd);
}

export function* setUserLogout({ payload }) {
  try {
    yield put(logoutUserInProgress());

    const obj = {
      id: payload
    };

    const result = yield call(setLogout, obj);

    deleteCookie();

    if (result.data.body === 'Success') {
      toastErrorHelper('Logged out!');
      browserHistory.push('/');
      yield put(logoutUserSuccess(result.data));
    } else {
      yield put(logoutUserFailure());
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    toastErrorHelper('Error loggin out!');
    console.warn('Error on changePwd', error);
    yield put(logoutUserFailure(error));
  }
}

export function* watchSetUserLogout() {
  yield takeLatest(LOGOUT_USER.START, setUserLogout);
}

export const authSagas = {
  watchSetUserLogin,
  watchSetUserForgotPwd,
  watchSetUserChangePwd,
  watchSetUserLogout,
  watchLoggedUser
};
